// TrendChart.jsx
import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";

import CardHeader from "../Layout/CardHeader";
import SuperInsightsModal from "../Ia/SuperInsightsModal";
import Meta from '../Layout/Meta';

const TrendChart = ({ item }) => {
  const safeItem = item || {};
  const {
    Sigla = '',
    Descricao_Dashboard_Componente: titulo = "-",
    dadosComponente = {},   
    Valor_Meta = {},
    Texto_Info = "-",
    Texto_BizAI = "",
    ESG_Info = "-",
    Codigo_Transacao_Link = "",
    Titulo_Transacao_Link = ""
  } = safeItem;

  const {
    valor = "0",
    prefixoMoeda = "R$",
    unidadeValor = ""
  } = dadosComponente || {};

  
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const togglePopup = () => setIsPopupOpen(!isPopupOpen);
  const slugId = Sigla.trim().replace(/\s+/g, "-");
  
  return (
    <>
      <Card className="w-100 card-dash-item">
        <CardBody className="w-100 h-100 d-flex flex-column cardbody-dash">
          <CardHeader
            titulo={titulo}
            Texto_Info={Texto_Info}
            ESG_Info={ESG_Info}
            togglePopup={togglePopup}
            slugId={slugId}
            textoIA={Texto_BizAI}
            Codigo_Transacao_Link={Codigo_Transacao_Link}
            Titulo_Transacao_Link={Titulo_Transacao_Link}
          />
    
          <Meta Valor_Meta={Valor_Meta} />
              
          <div className="mt-auto d-flex align-items-end justify-content-end">            
            <p className="mb-0 lh-1 text-color-cinza5 fw-bold font-size-30">
              {prefixoMoeda}
              {valor} <small className="">{unidadeValor}</small>
            </p>
          </div>
        </CardBody>
      </Card>

      <SuperInsightsModal
        isOpen={isPopupOpen}
        toggle={togglePopup}
        textoIA={Texto_BizAI} 
      />
    </>
  );
};

export default TrendChart;
